import React from 'react'
import {GetPageName,getUserRole} from '../Custom/Custom';
import { GlobalLoading } from 'react-global-loading';
import { Link } from 'react-router-dom'
import {jwtDecode} from "jwt-decode";
import { useNavigate } from "react-router-dom";


function NotFound() {

  let token=localStorage.getItem("jwt");
  const navigate = useNavigate();
  let pageText='';
  let pageNameObject=''
  let userRoleObject=''
  
   token =(token === "null" || token === null) ?'':token;
  if(token !=='' ){
    const userData = jwtDecode(token);
     userRoleObject = getUserRole(userData.id);
  }
  pageNameObject= GetPageName(userRoleObject); 


  if(pageNameObject.pagePath[0]==='Not Found' && token===''){
    pageText="before_login_page_not_found";
    navigate("/")
    window.location.pathname = "/";
  }else if(pageNameObject.pagePath[0] !=='Not Found' && token!==''){
  //  alert("loading");
  //  showLoading(true)
    // pageText='Loading.........';
  }else if(pageNameObject.pagePath[0]==='Not Found' && token!==''){ //after login
    pageText="after_login_page_not_found";
  }else if(pageNameObject.pagePath[0]!=='Not Found' && token===''){
    pageText='before_login_page_not_found';
    window.location.pathname = "/";
     navigate("/")
  }
 
  return (
    <>
    <GlobalLoading />

    { (pageText==='after_login_page_not_found') &&
        <div className="row ">
            <div className="card">
              <h4 className="p-3 text-center text-danger fw-bold">Page Not Found</h4>
            </div>
        </div>
    }

    {/* { (pageText==='before_login_page_not_found') &&
        <div className="row mt-5">
            <div className="card">
              <h4 className="p-3 text-center text-danger fw-bold">Please login</h4>
            </div>
            <div style={{textalign: "center"}}>
            <Link class="btn btn_orange"
                to="/">Login</Link>
             </div>
        </div>
    } */}
   
    </>
  )
}

export default NotFound